const MOJIBAKE_REPLACEMENTS: Array<[string, string]> = [
  ['绮惧噯缁欒嵂璁＄畻', '精准给药计算'],
  ['TDM 鍓傞噺浼樺寲', 'TDM 剂量优化'],
  ['AI 鏅鸿兘鍔╂墜', 'AI 智能助手'],
  ['PK 鏇茬嚎鍒嗘瀽', 'PK 曲线分析'],
  ['棰勬祴', '预测'],
  ['楂樹簬', '高于'],
  ['鎺ㄨ崘', '推荐'],
  ['鑼冨洿', '范围'],
  ['涓婇檺', '上限'],
  ['涓嬮檺', '下限'],
  ['瓒呰繃', '超过'],
  ['浣庝簬', '低于'],
  ['娴撳害', '浓度'],
  ['鐩爣', '目标'],
  ['锛屾瘨鎬ч闄╅珮', '，毒性风险高'],
  ['鍓傞噺', '剂量'],
  ['鍘熸湁鏂规', '原有方案'],
  ['鍘熸湁', '原有'],
  ['鏂规', '方案'],
  ['褰撳墠缁撴灉', '当前结果'],
  ['澶勪簬鐩爣鑼冨洿', '处于目标范围'],
];

const EXACT_USER_MESSAGE_TRANSLATIONS: Record<string, string> = {
  'Case not found': '病例不存在',
  'Calculation record not found': '计算记录不存在',
  'Optimize task not found': '剂量优化任务不存在或已过期',
  'Remedial dose calculation is not enabled': '该药物尚未启用补服/漏服计算',
  'Dose optimization returned no candidate regimen': '剂量优化未返回可用的候选给药方案',
  'Dose optimization candidates cannot be capped to the configured dose limit': '候选给药方案无法按后台配置的剂量上限进行限制',
  'Target concentration calculation returned no candidate regimens': '目标浓度计算未返回可用的候选给药方案',
  'Target concentration calculation returned an invalid recommended regimen': '目标浓度计算返回的推荐给药方案无效',
  'Target Cmax grid search returned no candidate regimens': '目标 Cmax 网格搜索未返回可用的候选给药方案',
  '%fT>MIC grid search returned no candidate regimens': '%fT>MIC 网格搜索未返回可用的候选给药方案',
  'Continuous infusion target is not configured': '尚未配置连续输注目标',
  'Missing configured candidate dosing intervals': '尚未配置候选给药间隔',
};

function localizeLegacyUserMessage(value: string): string {
  const exact = EXACT_USER_MESSAGE_TRANSLATIONS[value.replace(/\.$/, '')];
  if (exact) return exact;

  return value
    .replace(
      /%fT>MIC\s+([\d.]+)%\s+is below target\s+([\d.]+)%;\s*efficacy may be insufficient\.?/gi,
      '%fT>MIC 为 $1%，低于目标值 $2%，可能存在疗效不足。',
    )
    .replace(
      /PTA\s+([\d.]+)%\s*<\s*([\d.]+)%;\s*target attainment is low\.?/gi,
      'PTA 为 $1%，低于目标值 $2%，目标达成概率较低。',
    )
    .replace(
      /Predicted trough\s+([\d.]+)\s*mg\/L\s*>\s*([\d.]+)\s*mg\/L;\s*toxicity risk may increase\.?/gi,
      '预测谷浓度 $1 mg/L 高于 $2 mg/L，毒性风险可能增加。',
    )
    .replace(
      /Missing or invalid required positive covariate:\s*([^。；;]+)/gi,
      '缺少或无效的必需正数协变量：$1',
    )
    .replace(
      /Missing or invalid required positive value:\s*([^。；;]+)/gi,
      '缺少或无效的必需正数参数：$1',
    )
    .replace(
      /Missing required model covariate:\s*([^。；;]+)/gi,
      '模型缺少必需协变量：$1',
    )
    .replace(
      /object ['\"](.+?)['\"] not found/gi,
      '模型脚本缺少对象“$1”',
    )
    .replace(/Target concentration calculation failed:\s*/gi, '目标浓度计算失败：')
    .replace(/Dose optimization failed:\s*/gi, '剂量优化失败：');
}

export function sanitizeMojibakeString(value: string): string {
  const sanitized = MOJIBAKE_REPLACEMENTS.reduce(
    (text, [bad, good]) => text.split(bad).join(good),
    value,
  );
  return localizeLegacyUserMessage(sanitized);
}

function isPlainObject(value: unknown): value is Record<string, unknown> {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
}

export function sanitizeMojibakeText<T>(value: T): T {
  if (typeof value === 'string') {
    return sanitizeMojibakeString(value) as T;
  }
  if (Array.isArray(value)) {
    return value.map(item => sanitizeMojibakeText(item)) as T;
  }
  if (isPlainObject(value)) {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([key, item]) => [
        key,
        sanitizeMojibakeText(item),
      ]),
    ) as T;
  }
  return value;
}
